var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRollingSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "rolling-smiley__icon",
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "rolling-smiley__bg",
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#F2C94C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "rolling-smiley__inner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rolling-smiley__border",
    d: "M32 0C25.671 0 19.4841 1.87677 14.2218 5.39297C8.95939 8.90918 4.85787 13.9069 2.43587 19.7541C0.0138652 25.6014 -0.619842 32.0355 0.614885 38.2429C1.84961 44.4503 4.89732 50.1521 9.3726 54.6274C13.8479 59.1027 19.5497 62.1504 25.7571 63.3851C31.9645 64.6199 38.3987 63.9862 44.2459 61.5642C50.0931 59.1421 55.0908 55.0406 58.607 49.7783C62.1232 44.5159 64 38.329 64 32C63.9903 23.5161 60.6158 15.3824 54.6167 9.3833C48.6177 3.38424 40.484 0.00970452 32 0V0ZM32 61.3333C26.1984 61.3333 20.5271 59.613 15.7033 56.3898C10.8794 53.1666 7.11972 48.5854 4.89955 43.2254C2.67938 37.8654 2.09848 31.9675 3.23031 26.2774C4.36215 20.5872 7.15588 15.3605 11.2582 11.2582C15.3606 7.15586 20.5873 4.36213 26.2774 3.2303C31.9675 2.09847 37.8654 2.67936 43.2254 4.89953C48.5854 7.1197 53.1666 10.8794 56.3898 15.7033C59.613 20.5271 61.3334 26.1984 61.3334 32C61.3246 39.777 58.2313 47.2329 52.7321 52.7321C47.2329 58.2313 39.777 61.3246 32 61.3333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rolling-smiley__left-eye",
    d: "M18.6665 16H23.9998V26.6667H18.6665V16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rolling-smiley__right-eye",
    d: "M40 16H45.3333V26.6667H40V16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rolling-smiley__mouth",
    d: "M31.9998 50.6667C28.1113 50.6623 24.3834 49.1156 21.6338 46.366C18.8842 43.6165 17.3376 39.8885 17.3332 36H14.6665C14.6665 40.5971 16.4927 45.0059 19.7433 48.2565C22.9939 51.5071 27.4027 53.3333 31.9998 53.3333C36.5969 53.3333 41.0057 51.5071 44.2563 48.2565C47.507 45.0059 49.3332 40.5971 49.3332 36H46.6665C46.6621 39.8885 45.1155 43.6165 42.3659 46.366C39.6163 49.1156 35.8883 50.6623 31.9998 50.6667Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollingSmile);
export default __webpack_public_path__ + "static/media/rolling-smile.a11fffcdd0d6f34a137deebe61c97d93.svg";
export { ForwardRef as ReactComponent };